import axios from 'axios';
import { useContext, useEffect } from 'react';
import {useTheme} from '@emotion/react';
import {useMediaQuery} from '@dnhb/node_package';
import Header from '../../../shared/Header';
import {Box} from '../../../shared/layouts';
import Stack from '../../../shared/layouts/Stack';
import MessagebarContext from '../../../../context/MessagebarContext';
import {useQuery} from 'react-query';
import Process from "../components/Process";
import {useTranslation} from "react-i18next";

const ProcessSection = ({ setIsLoading }) => {
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.desktop ?? '37.5rem'})`
  );
  const { setAlertMessage } = useContext(MessagebarContext);

  const { t } = useTranslation();

  const { isLoading, data = [] } = useQuery(
    'processes',
    async () =>
      await axios
        .get('/processes')
        .then(({ data }) => data.processes)
        .catch(() => setAlertMessage())
  );

  useEffect(() => {
    if (!isLoading) setIsLoading(false);
  }, [isLoading, setIsLoading]);

  if (data.length === 0) return null;

  return (
    <Stack space="m">
      <Header title={t("Voortgang")} variant="page" />
      <Box
        maxWidth={{ mobile: '100vw', desktop: 'unset' }}
        css={{ overflowX: isMinDesktop ? null : 'auto' }}
      >
        <Stack
          direction={isMinDesktop ? 'column' : 'row'}
          space={isMinDesktop ? 'm' : 'xl'}
        >
          {data.map((obj, i) => {
            return <Process data={obj} key={i} />;
          })}
        </Stack>
      </Box>
    </Stack>
  );
};

export default ProcessSection;
